import Swiper from 'swiper';
import 'swiper/css/bundle';

const locationsDots = document.querySelectorAll('.locations-dot');

let locationsSwiper;

locationsSwiper = new Swiper('.locations-swiper-container', {
  direction: 'horizontal',
  loop: false,
  grabCursor: true,
  centeredSlides: false,
  slidesPerView: 2,
  slidesPerGroup: 2,
  initialSlide: 0,
  spaceBetween: 12,
  grabCursor: true,
  allowTouchMove: true,
  speed: 500,
  breakpoints: {
    1440: {
      centeredSlides: false,
      slidesPerView: 6,
      grabCursor: false,
      allowTouchMove: false,
      spaceBetween: 0,
    },
  },
  on: {
    init: () => {
      document
        .querySelector('.locations-swiper-container')
        .classList.add('show');
    },
    slideChange: function () {
      const page = Math.floor(this.activeIndex / this.params.slidesPerGroup);

      updateLocationsDots(page);
    },
  },
});

function updateLocationsDots(index) {
  locationsDots.forEach((dot, i) => {
    dot.classList.toggle('active', i === index);
  });
}

locationsDots.forEach((dot, index) => {
  dot.addEventListener('click', () => {
    locationsSwiper.slideTo(index * locationsSwiper.params.slidesPerGroup);
  });
});
